import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新建")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("添加其他提成")
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("提成明细表")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("提成明细表")
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("批量删除")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import router from '@/router/index'
import {statusFunc, typeFunc} from '@/views/typeMapping/Commission'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props: any) {

const props = __props as {}

const {
  // 提成管理搜索
  'POST/commission/manage': fetchList,
  // 创建提成管理
  'POST/commission/manage/create': createCommissionApi,
  // 删除
  'DELETE/commission/manage/{id}': delCommissionApi,
  // 提成管理详情查询
  'POST/commission/manage/detail': detailApi,
  // 确认并推送
  'PUT/commission/manage/confirm/{id}': confirmManageApi,
  // 创建提成管理明细
  'POST/commission/manage/detail/create': createDetailApi,
  // 提成管理详情推送前校验
  'PUT/commission/manage/validate/{id}': validateApi,
  // 除提成管理明细
  'POST/commission/manage/detail/del': delApi,
  // 删除校验出的错误数据
  'POST/commission/manage/validate/del': validateDelApi,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchObj = reactive({
  month: '',
})
const searchHandle = () => {
  fetchData(searchObj)
}
searchHandle()

// 添加
const isBtnLoad = ref<boolean>(false)
const createdObj = reactive({
  month: '', type: ''
})
const isShowCreated = ref<boolean>(false)
const showCreatedHandle = () => {
  isShowCreated.value = true
}
const submitCreated = () => {
  isBtnLoad.value = true
  createCommissionApi(createdObj, {contentType: 'formData'}).then(() => {
    ElMessage.success('新建成功')
    searchHandle()
    isShowCreated.value = false
  }).finally(() => {
    isBtnLoad.value = false
  })
}

// 详情查询
const { 
  MI_tableData: detailData, fetchData: fetchDetail, page: detailPage, size: detailSize,
  MI_total: detailTotal, MI_pageChange: detailPgCg, MI_sizeChange: detailSzCg, MI_identify: detailIdentify
} = new tbMix(detailApi)
const isShowDetails = ref<boolean>(false)
const detailSearchObj = reactive({
  name: '', orgId: ''
})
let detailRow: any = reactive({})
const showDetailsHandle = (row: any) => {
  // detailRow = row
  Object.assign(detailRow, row)
  isShowDetails.value = true
  fetchDetail({manageId: row.id})
}
const searchDetails = () => {
  fetchDetail({manageId: detailRow.id, ...detailSearchObj})
}

// 确认推动详情
const isShowTips = ref<boolean>(false)
let ownerList = ref<string[]>([])
const confirmHandle = () => {
  // 推送前校验
  detailIdentify.value = true
  validateApi({
    id: detailRow.id
  }).then((tipStr: string[]) => {
    detailIdentify.value = true
    // 无异常
    if(tipStr.length === 0){
      return ElMessageBox.confirm('请确认是否推送', '提示')
    }
    // 异常弹框提示
    ownerList.value = tipStr;
    isShowTips.value = true
    
    // ElMessageBox.confirm(tipStr.join('，'), '提示: 以下人员无法匹配到系统员工信息', {type: 'warning', confirmButtonText: '批量删除'})
    return Promise.reject()
  }).then(() => {
    detailIdentify.value = true
    return confirmManageApi({id: detailRow.id})
  }).then(() => {
    ElMessage.success('推送成功')
    isShowDetails.value = false
  }).finally(() => {
    detailIdentify.value = false
  })
}
const batchDelHandle = () => {
  ElMessageBox.confirm(
    `将要删除${ownerList.value.join('，')}这些人的提成数据，请确认删除`,
    '提示',
    {type: 'warning', confirmButtonText: '确认删除'}
  ).then(() => {
    isShowTips.value = false
    detailIdentify.value = true
    return validateDelApi({
      manageId: detailRow.id,
      ownerList: ownerList.value
    })
  }).then(() => {
    detailIdentify.value = false
    ElMessage.success('删除成功')
  }).finally(() => {
    detailIdentify.value = false
  })
}

// 添加其他提成
const isShowOhter = ref<boolean>(false)
const isOtherLoad = ref<boolean>(false)
const addEle = ref()
const addOtherObj = reactive({
  userId: '', note: '', amount: undefined,
})
const addOtherComHandle = () => {
  isShowOhter.value = true
  nextTick(() => {
    addEle.value.resetFields()
  })
}
const submitAddOther = () => {
  if(!addOtherObj.userId || !addOtherObj.amount) {
    ElMessage.warning('请选择提成人或输入金额')
    return
  }
  isOtherLoad.value = true
  createDetailApi({
    ...addOtherObj,
    userId: addOtherObj.userId.userId,
    owner: addOtherObj.userId.alias,
    manageId: detailRow.id,
  }).then(() => {
    ElMessage.success('添加成功')
    isShowOhter.value = false
    fetchDetail({manageId: detailRow.id})
  }).finally(() => {
    isOtherLoad.value = false
  })
}
// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm('请确认是否删除', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return delCommissionApi(row, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('删除成功')
    MI_identify.value = false
    searchHandle()
  }).finally(() => {
    MI_identify.value = false
  })
}

// 详情删除
const delDetailHandle = (row: {detailIds: number[]}) => {
  ElMessageBox.confirm(`请确认是否删除?`, '提示').then(() => {
    MI_identify.value = true
    return delApi({ detailIds: row.detailIds })
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('删除成功')
    showDetailsHandle(detailRow)
  }).catch(() => {
    MI_identify.value = false
  })
}

const switchDetails = (row: any) => {
  router.push({path: '/comission', query: {ids: row.orderNos.join(',')}})
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _unref(searchObj),
              inline: "",
              disabled: _unref(MI_identify),
              class: "searchBg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "时间:",
                  prop: "month"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).month,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).month) = $event)),
                      type: "month",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "请选择月份"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (showCreatedHandle())),
      type: "primary",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height),
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "计算提成月份",
          prop: "month"
        }),
        _createVNode(_component_el_table_column, {
          label: "CO2计算结果（USD）",
          prop: "usdAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "",
          prop: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "提成类型",
          prop: "type",
          formatter: (row) => _unref(typeFunc)()[row.type]
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          formatter: (row) => _unref(statusFunc)()[row.status]
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (showDetailsHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      disabled: _unref(MI_identify),
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowCreated.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isShowCreated).value = $event)),
      title: "新建提成"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (isShowCreated.value = false)),
          disabled: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (submitCreated())),
          loading: isBtnLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _unref(createdObj),
          "label-width": "auto",
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "计算提成月份:",
              prop: "month"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(createdObj).month,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(createdObj).month) = $event)),
                  clearable: "",
                  type: "month",
                  placeholder: "请选择月份",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "提成类型:",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(createdObj).type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(createdObj).type) = $event)),
                  placeholder: "请选择提成类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "基准提成",
                      value: "basis"
                    }),
                    _createVNode(_component_el_option, {
                      label: "销售补充",
                      value: "supplement"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowDetails.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isShowDetails).value = $event)),
      title: "详情",
      fullscreen: "",
      onClose: _cache[17] || (_cache[17] = ($event: any) => (searchHandle()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "",
          model: _unref(detailSearchObj),
          "label-position": "left",
          inline: "",
          class: "searchBg mb-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "英文名:",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  onKeyup: _withKeys(searchDetails, ["enter"]),
                  class: "form-input",
                  modelValue: _unref(detailSearchObj).name,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(detailSearchObj).name) = $event)),
                  placeholder: "请输入英文名",
                  clearable: "",
                  maxlength: "100"
                }, null, 8, ["onKeyup", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "团队:",
              prop: "orgId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: "请选择团队",
                  modelValue: _unref(detailSearchObj).orgId,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(detailSearchObj).orgId) = $event)),
                  filterable: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: org.name,
                        value: org.id,
                        key: org.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  onClick: searchDetails,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        (!['issued', 'confirmed'].includes(_unref(detailRow).status))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (confirmHandle())),
              disabled: _unref(detailIdentify)
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (!['issued', 'confirmed'].includes(_unref(detailRow).status))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              onClick: _cache[13] || (_cache[13] = ($event: any) => (addOtherComHandle())),
              disabled: _unref(detailIdentify)
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "tb",
          data: _unref(detailData),
          "max-height": "800px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "expand" }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_table, {
                    data: row.detailData,
                    class: "ml-30",
                    style: {"width":"800px"},
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "提成类型",
                        prop: "type",
                        formatter: (row) => _unref(typeFunc)()[row.type]
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "来源",
                        prop: "source"
                      }, {
                        default: _withCtx(({row}) => [
                          (row.source === '提成明细表')
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 0,
                                type: "primary",
                                onClick: ($event: any) => (switchDetails(row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.source), 1))
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_table_column, {
                        label: "备注",
                        prop: "note",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "本月金额",
                        prop: "amount",
                        align: "right",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"])
                    ]),
                    _: 2
                  }, 1032, ["data"]),
                  _createVNode(_component_el_table, {
                    data: row.detailData,
                    class: "ml-30",
                    style: {"width":"700px"},
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "提成类型",
                        prop: "type",
                        formatter: (row) => _unref(typeFunc)()[row.type]
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "来源",
                        prop: "source"
                      }, {
                        default: _withCtx(({row}) => [
                          (row.source === '提成明细表')
                            ? (_openBlock(), _createBlock(_component_el_link, {
                                key: 0,
                                type: "primary",
                                onClick: ($event: any) => (switchDetails(row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row.source), 1))
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_table_column, {
                        label: "备注",
                        prop: "note",
                        "show-overflow-tooltip": ""
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "CO2计算结果（USD）",
                        prop: "usdAmount",
                        align: "right",
                        formatter: _unref(formatNumber)
                      }, null, 8, ["formatter"])
                    ]),
                    _: 2
                  }, 1032, ["data"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "提成人",
              prop: "owner"
            }),
            _createVNode(_component_el_table_column, {
              label: "计算提成月份",
              prop: "month"
            }),
            _createVNode(_component_el_table_column, {
              label: "总提成金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "CO2计算结果（USD）",
              prop: "usdAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "状态",
              prop: "status",
              formatter: (row) => _unref(statusFunc)()[row.status]
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "100"
            }, {
              default: _withCtx(({row}) => [
                (row.status === 'to_be_confirmed')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      onClick: ($event: any) => (delDetailHandle(row)),
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(detailIdentify)]
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          disabled: _unref(detailIdentify),
          total: _unref(detailTotal),
          currentPage: _unref(detailPage),
          "onUpdate:currentPage": _cache[14] || (_cache[14] = ($event: any) => (_isRef(detailPage) ? (detailPage).value = $event : null)),
          "page-size": _unref(detailSize),
          "onUpdate:page-size": _cache[15] || (_cache[15] = ($event: any) => (_isRef(detailSize) ? (detailSize).value = $event : null)),
          class: "mt-10",
          style: {"float":"none"},
          "page-sizes": [10, 30, 50, 100, 300],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(detailPgCg),
          onSizeChange: _unref(detailSzCg)
        }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowOhter.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((isShowOhter).value = $event)),
      title: "添加其他提成"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[21] || (_cache[21] = ($event: any) => (isShowOhter.value = false)),
          disabled: isOtherLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (submitAddOther())),
          loading: isOtherLoad.value
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addEle",
          ref: addEle,
          model: _unref(addOtherObj),
          "label-position": "top",
          "label-width": "80px",
          disabled: isOtherLoad.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "提成人:",
              prop: "userId",
              rules: [{ required: true, message: '请选择提成人', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(addOtherObj).userId,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(addOtherObj).userId) = $event)),
                  placeholder: "请选择提成人",
                  "value-key": "userId",
                  class: "form-input",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: user.userId,
                        label: user.alias,
                        value: user
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "金额:",
              prop: "amount",
              rules: [{ required: true, message: '请选输入金额', trigger: 'change'}]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  modelValue: _unref(addOtherObj).amount,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(addOtherObj).amount) = $event)),
                  class: "form-input",
                  placeholder: "请输入金额"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "币种:",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  placeholder: "CNY",
                  disabled: ""
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注:",
              prop: "note"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _unref(addOtherObj).note,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addOtherObj).note) = $event)),
                  maxlength: "400",
                  rows: "4",
                  placeholder: "请输入备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowTips.value,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((isShowTips).value = $event)),
      title: "提示: 以下人员无法匹配到系统员工信息",
      width: "550"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[24] || (_cache[24] = ($event: any) => (batchDelHandle())),
          type: "danger"
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (isShowTips.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(ownerList).join('，')) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})